/* eslint-disable max-len */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { ReactComponent as ComingSoonLogo } from 'assets/CarBrand/brand_coming_soon.svg';
import { IAM } from 'domains/catalog/Catalog.types';
import { Icon, ImageWithLoader } from 'UI';
import { ReferenceBrandContainer } from './IAMReferenceCard.styled';

const ReferenceImage = ({
  brandImage,
  referenceImage,
  imageHeight = 120,
  imageWidth = 135,
}: {
  brandImage?: string;
  referenceImage?: string;
  imageHeight?: number;
  imageWidth?: number;
}) => {
  const { t } = useTranslation();
  const { color } = useTheme();
  const alt = t('catalog.iam.reference_card.reference_image', 'IAM reference preview image');
  const brandHeight = Math.floor(imageHeight / 4);
  if (!referenceImage && !brandImage) {
    return (
      <Icon
        IconComponent={ComingSoonLogo}
        background={color.shadow_7}
        height={120}
        width={140}
        noPointer={true}
        data-cy={'reference-image-default'}
      />
    );
  }

  if (!referenceImage) {
    return (
      <ImageWithLoader
        alt={alt}
        imageUrl={brandImage}
        imageHeight={imageHeight}
        imageWidth={imageWidth}
        cursor={'auto'}
      />
    );
  }
  return (
    <>
      <ImageWithLoader
        alt={alt}
        imageUrl={referenceImage}
        imageHeight={imageHeight}
        imageWidth={imageWidth}
        cursor={'pointer'}
        catalogSource={IAM}
      />
      <ReferenceBrandContainer>
        <ImageWithLoader alt={alt} imageUrl={brandImage} imageHeight={brandHeight} />
      </ReferenceBrandContainer>
    </>
  );
};

export default ReferenceImage;
